import React, { useEffect } from 'react'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import _ from "lodash";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const IncomeTypeStackChart = ({ data, xAxis, }) => {

    useEffect(() => {

        // Create chart instance
        let chart = am4core.create("chart-type-income", am4charts.XYChart) as any;
        chart.colors.step = 2;

        // chart.data = data;

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis()) as any;
        categoryAxis.dataFields.category = xAxis;
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 20;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "ล้านบาท";
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1;
        valueAxis.numberFormatter = new am4core.NumberFormatter();
        valueAxis.numberFormatter.numberFormat = "#.00"; 
        valueAxis.adjustLabelPrecision = false;
        
        chart.data = data;

        if (data.length !== 0) {
            let cloneData = _.cloneDeep(data) || [];
            cloneData.forEach(element => {
                (element.lstIncomeType || []).forEach(subElement => {
                    element[subElement.sField] = subElement.sValue;
                })
            });
            chart.data = cloneData;

            let letRenderBar = data[0].lstIncomeType || [];
            letRenderBar.forEach(element => {
                createSeries(element.sField, element.sName, true, element.sName);
            });
        }

        // Create series
        function createSeries(field, name, stacked, sTooltip) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = xAxis;
            series.name = name;
            // series.columns.template.tooltipText = sTooltip + ": [bold]{valueY}[/]";
            series.stacked = stacked;
            series.columns.template.width = am4core.percent(50);
            series.tooltipText = sTooltip + ": [bold]{valueY}[/]";

            // Add label
            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.fontSize = 10;
            labelBullet.label.fontWeight = "normal";
            labelBullet.label.hideOversized = true;
            labelBullet.interactionsEnabled = false
            labelBullet.label.text = "{valueY.formatNumber('#.00')}";
            labelBullet.locationY = 0.5;
            labelBullet.label.fill = am4core.color("#FFFFFF");
        }

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "รายได้ตามแผน";
        lineSeries.dataFields.valueY = "nTotalPlan";
        lineSeries.dataFields.categoryX = xAxis;
        lineSeries.showOnInit = true;
        lineSeries.stroke = am4core.color("#ffc000");
        lineSeries.strokeWidth = 2;
        lineSeries.propertyFields.strokeDasharray = "lineDash";
        lineSeries.tooltip.label.textAlign = "middle";
        lineSeries.tooltipText = "[#fff font-size: 14px]รายได้ตามแผน:[/][#fff font-size: 14px]{valueY.formatNumber('#.00')}[/]"

        let labelBullet = lineSeries.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.text = "{valueY.formatNumber('#.00')}";
        labelBullet.dy = -10;

        let bullet = lineSeries.bullets.push(new am4charts.Bullet());
        // bullet.tooltipText = "[#fff font-size: 14px]รายได้ตามแผน:[/][#fff font-size: 14px]{valueY.formatNumber('#.00')}[/]"
        let circle = bullet.createChild(am4core.Circle);
        circle.radius = 3;
        circle.fill = am4core.color("#fff");
        circle.strokeWidth = 1;

        /* Create legend */
        chart.legend = new am4charts.Legend();


        chart.cursor = new am4charts.XYCursor();
        chart.cursor.fullWidthLineX = true;
        chart.cursor.xAxis = categoryAxis;
        chart.cursor.lineX.strokeOpacity = 0;
        chart.cursor.lineX.fill = am4core.color("#000");
        chart.cursor.lineX.fillOpacity = 0.1;

        // Cleanup on component unmount
        return () => {
            chart.dispose();
        };

    }, [data, xAxis])


    return (
        <div id="chart-type-income" style={{ width: "100%", height: "500px" }}></div>
    )
}

export default IncomeTypeStackChart